import { render, staticRenderFns } from "./DataClients.vue?vue&type=template&id=34f296b0&"
import script from "./DataClients.vue?vue&type=script&lang=js&"
export * from "./DataClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports